import styles from "./styles.scss";
import {Body} from "../typography";

const ListItem = ({ left, right, title, subtitle, onClick, onMouseEnter, onMouseLeave, loading, className = '', style, hoverFeedback = false, fadedSubtitle = false, ...others }) => (
  <a
    onClick={onClick}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    style={style}
    className={[styles.container, onClick && styles.cursorPointer, hoverFeedback && styles.containerClickable, className].join(" ")}
    {...others}
  >
    {left}
    <div className={[styles.main, left && styles.mainWithLeft, right && styles.mainWithRight].join(" ")}>
      {(typeof title === "string" || loading) ? <Body size={"body2"} loading={loading}>{title}</Body> : title}
      {(typeof subtitle === "string" || loading) ? <Body style={{marginTop: loading ? 4 : 0}} className={fadedSubtitle && styles.fadedSubtitleColor} wireframeWidth={120} loading={loading} size={"body2"}>{subtitle}</Body> : subtitle}
    </div>
    {right}
  </a>
);

export default ListItem;



// WEBPACK FOOTER //
// ./components/list-item/index.js